export type SaveBlocker = { blocked: boolean; reason: string | null };

export type SaveState = {
  blocker: SaveBlocker;
  isPending: boolean;
  save?: () => Promise<void | boolean>;
  requiresProductClosureConfirmation?: boolean;
  addsServiceRoles?: boolean;
};

export const DEFAULT_SAVE_STATE: SaveState = {
  blocker: { blocked: true, reason: null },
  isPending: false,
};

export const getSaveGate = (blockers: SaveBlocker[]) => {
  const activeBlockers = blockers.filter((blocker) => blocker.blocked);

  return {
    canSave: activeBlockers.length === 0,
    reasons: activeBlockers.flatMap((blocker) => blocker.reason ?? []),
  };
};
